<template>
    <div>
        <WelcomeVideo/>
        <About id="about"/>
        <Services id="services" :services="services"/>
        <GuidedTours id="guided-tours"/>
        <Articles id="publications" :title="'Publicações'" :articles="articles" :more="true"/>
        <Contacts id="contacts"/>
    </div>
</template>

<script>
    import About from "./main/About";
    import Services from "./main/Services";
    import GuidedTours from "./main/GuidedTours";
    import Contacts from "./main/Contacts";
    import WelcomeVideo from "./main/WelcomeVideo";

    import {getArticles, getServices} from "../services/data.service";
    import Articles from "./main/Articles";

    export default {
        name: "Main",
        components: {
            Articles,
            Contacts,
            GuidedTours,
            Services,
            About,
            WelcomeVideo
        },
        data() {
            return {
                services: null,
                portfolios: null,
                articles: null
            }
        },
        mounted() {
            getServices().subscribe(services => {
                this.services = services;
            });

            getArticles().subscribe(articles => {
                this.articles = articles;
            });
        }
    }
</script>

<style scoped>

</style>
